<section class="services-section" id="services">
  <div class="services-section__intro">
    <h2 class="services-section__title">
      Sitco is a software<br>
      development studio<br>
      based in Yaroslavl
    </h2>

    <a
      class="services-section__cta"
      routerLink="/"
      fragment="contact">
      <span class="services-section__cta-text">
        Start the project
      </span>

      <span
        class="services-section__cta-button"
        aria-hidden="true">
        <span
          class="services-section__arrow services-section__arrow--current"></span>
        <span
          class="services-section__arrow services-section__arrow--next"></span>
      </span>
    </a>
  </div>

  <div class="services-section__content">
    <div class="services-section__description">
      <p>
        We deliver custom software solutions for businesses worldwide since
        2015, helping companies transform ideas into scalable digital products.
      </p>

      <p>
        From concept to launch, we create reliable solutions tailored to
        business needs — improving operations, performance, and long-term
        growth with a strong focus on quality, security, and success.
      </p>
    </div>

    <div class="services-section__list">
      <article
        class="services-section__item"
        *ngFor="let service of services">
        <h3 class="services-section__item-title">
          {{ service.title }}
        </h3>

        <p class="services-section__item-description">
          {{ service.description }}
        </p>
      </article>
    </div>
  </div>
</section>
